import { API_URL } from "../Config";
import { PageResult } from "../Pagination";

export interface IComplianceInvestigationOutcome {
  cioutcomeid: string;
  outcometype: string;
  outcomecategory: string;
  outcomesubcategory: string;
  description: string;
  complianceinvestigationid: string;
}

export interface IComplianceInvestigationOutcomeList extends PageResult {
  list: IComplianceInvestigationOutcome[];
}

export const GetComplianceInvestigationOutcomesFetchUrl = (
  complianceInvestigationId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  var params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  let url = `${API_URL}/Ci/listcioutcomes?ci_id=${complianceInvestigationId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/ci-outcomes`;
  }

  return url;
};

export function FormatComplianceList(rows: Array<any>) {
  return rows.map((item) => {
    return <IComplianceInvestigationOutcome>{
      cioutcomeid: item.cioutcomeid,
      outcometype: item.outcometype,
      outcomecategory: item.outcomecategory,
      outcomesubcategory: item.outcomesubcategory,
      description: item.description,
      complianceinvestigationid: item.complianceinvestigationid,
    };
  });
}
